import {
  PictureOutlined, BorderOuterOutlined, ToolOutlined,
  BuildOutlined, ShopOutlined, GlobalOutlined
} from '@ant-design/icons';
import { ITEM_NATURES } from '../productStudioModes';

// ─────────────────────────────────────────────────────────────────
// Item-nature picker — 6 cards.
// Glass / Profile / Hardware / Jobwork / Trading / Ecommerce.
// Each card has an icon + title + one-line description (copy from
// productStudioModes.js). Pure controlled component.
// ─────────────────────────────────────────────────────────────────

const ICONS = {
  glass:     <PictureOutlined style={{ fontSize: 22, color: '#1877F2' }} />,
  profile:   <BorderOuterOutlined style={{ fontSize: 22, color: '#7C3AED' }} />,
  hardware:  <ToolOutlined style={{ fontSize: 22, color: '#F59E0B' }} />,
  jobwork:   <BuildOutlined style={{ fontSize: 22, color: '#10B981' }} />,
  trading:   <ShopOutlined style={{ fontSize: 22, color: '#64748B' }} />,
  ecommerce: <GlobalOutlined style={{ fontSize: 22, color: '#E11D48' }} />
};

export default function ProductNatureCards({ value, onChange }) {
  return (
    <div className="erp-studio-nature-grid" role="radiogroup" aria-label="Item nature">
      {ITEM_NATURES.map((n) => {
        const active = value === n.key;
        return (
          <button
            key={n.key}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(n.key)}
            className={`erp-studio-nature-card ${active ? 'is-active' : ''}`}
          >
            <div className="erp-studio-nature-card__icon">{ICONS[n.key]}</div>
            <div className="erp-studio-nature-card__body">
              <div className="erp-studio-nature-card__title">{n.label}</div>
              <div className="erp-studio-nature-card__desc">{n.description}</div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
